import { combineReducers } from 'redux'
import profile from './profile'
import upload from './upload'
import panel from './panel'
import target from './target'
import targetgroup from './targetgroup'
import address from './address'
import request from './request'
import panelChange from './panelChange'
import city from './city'
import user from './user'
import dailyOpener from './dailyOpener'
import consent from './consent'
import setting from './setting'
import panelConsent from './panelConsent'

// Combine reducers into one reducer
const combinedReducer = combineReducers({ dailyOpener, user, setting, profile, targetgroup, city, upload, panel, target, address, request, panelChange, consent, panelConsent });

export default combinedReducer;